import React, { useState } from 'react';
import { changePassword } from '../../services/api';

function ChangePasswordForm() {
  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');

    // Validation
    if (!currentPassword || !newPassword || !confirmPassword) {
      setError('All fields are required');
      return;
    }

    if (newPassword.length < 6) {
      setError('New password must be at least 6 characters');
      return;
    }

    if (newPassword !== confirmPassword) {
      setError('New passwords do not match');
      return;
    }

    setIsLoading(true);
    const result = await changePassword(currentPassword, newPassword);
    setIsLoading(false);

    if (result.error) {
      setError(result.error);
    } else {
      setSuccess('Password changed successfully');
      setCurrentPassword('');
      setNewPassword('');
      setConfirmPassword('');
    }
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-4">
      {error && (
        <div className="bg-red-900/20 border border-red-500/50 text-red-300 px-4 py-3 rounded text-sm">
          {error}
        </div>
      )}

      {success && (
        <div className="bg-green-900/20 border border-green-500/50 text-green-300 px-4 py-3 rounded text-sm">
          {success}
        </div>
      )}

      <div>
        <label className="block text-sm text-muted mb-1">Current Password</label>
        <input
          type="password"
          value={currentPassword}
          onChange={(e) => setCurrentPassword(e.target.value)}
          className="w-full p-3 bg-gray-800 border border-brand-gray-blue rounded focus:outline-none focus:ring-2 focus:ring-brand-blue focus:border-brand-blue text-brand-white placeholder-gray-400"
          placeholder="Enter current password"
          disabled={isLoading}
        />
      </div>

      <div>
        <label className="block text-sm text-muted mb-1">New Password</label>
        <input
          type="password"
          value={newPassword}
          onChange={(e) => setNewPassword(e.target.value)}
          className="w-full p-3 bg-gray-800 border border-brand-gray-blue rounded focus:outline-none focus:ring-2 focus:ring-brand-blue focus:border-brand-blue text-brand-white placeholder-gray-400"
          placeholder="Enter new password (min 6 characters)"
          disabled={isLoading}
        />
      </div>

      <div>
        <label className="block text-sm text-muted mb-1">Confirm New Password</label>
        <input
          type="password"
          value={confirmPassword}
          onChange={(e) => setConfirmPassword(e.target.value)}
          className="w-full p-3 bg-gray-800 border border-brand-gray-blue rounded focus:outline-none focus:ring-2 focus:ring-brand-blue focus:border-brand-blue text-brand-white placeholder-gray-400"
          placeholder="Confirm new password"
          disabled={isLoading}
        />
      </div>

      <button
        type="submit"
        className="w-full bg-brand-blue text-white font-semibold py-3 rounded-lg hover:bg-[#1a7aef] transition-colors disabled:bg-brand-blue/50 disabled:cursor-not-allowed"
        disabled={isLoading}
      >
        {isLoading ? 'Changing Password...' : 'Change Password'}
      </button>
    </form>
  );
}

export default ChangePasswordForm;
